module.exports = __webpack_public_path__ + "img/buy0237.414a66a5.svg";